export default __webpack_public_path__ + "static/media/video-play.f7de1846.svg";